import { render, staticRenderFns } from "./EmptyCard.vue?vue&type=template&id=19ceb87c&scoped=true&"
import script from "./EmptyCard.vue?vue&type=script&lang=js&"
export * from "./EmptyCard.vue?vue&type=script&lang=js&"
import style0 from "./EmptyCard.vue?vue&type=style&index=0&id=19ceb87c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19ceb87c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
